// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-me-js": () => import("./../../src/pages/about-me.js" /* webpackChunkName: "component---src-pages-about-me-js" */),
  "component---src-pages-carpool-show-js": () => import("./../../src/pages/carpoolShow.js" /* webpackChunkName: "component---src-pages-carpool-show-js" */),
  "component---src-pages-hedwig-show-js": () => import("./../../src/pages/HedwigShow.js" /* webpackChunkName: "component---src-pages-hedwig-show-js" */),
  "component---src-pages-index-js": () => import("./../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-my-works-js": () => import("./../../src/pages/my-works.js" /* webpackChunkName: "component---src-pages-my-works-js" */),
  "component---src-pages-using-typescript-tsx": () => import("./../../src/pages/using-typescript.tsx" /* webpackChunkName: "component---src-pages-using-typescript-tsx" */)
}

